var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"container_2"},[_c('div',{staticClass:"box1"},[_vm._v("1")]),_c('div',{staticClass:"box2"},[_vm._v("2")]),_c('div',{staticClass:"box3"},[_vm._v("3")]),_c('div',{staticClass:"box4"},[_vm._v("4")]),_c('div',{staticClass:"box5"},[_vm._v("5")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }